import { all, fork } from 'redux-saga/effects';
import { publishTermsCommercialSagas, publishTermsSagas } from '../redux/sagas/publishTerms';
import { betPositionSagas } from '../redux/sagas/betPosition';
import { fairPlaySagas } from '../redux/sagas/fairPlay';
import { offerSagas } from '../redux/sagas/offer';
import { publishInfoSagas } from '../redux/sagas/publishInfo';
import { disableFormsSagas } from '../redux/sagas/disableForms';
import { draftSagas } from './draft';
import { autopublishSagas } from './autopublish';
import { rosreestrDataSagas } from './rosreestrData';
import { businessRootSaga } from '../redux/sagas/business';

export function* rootSaga() {
  yield all(
    [
      publishTermsSagas,
      publishTermsCommercialSagas,
      betPositionSagas,
      fairPlaySagas,
      offerSagas,
      publishInfoSagas,
      disableFormsSagas,
      draftSagas,
      autopublishSagas,
      rosreestrDataSagas,
      businessRootSaga,
    ].map(fork),
  );
}
